import { LOAD_CHANNELS_SHORT } from '@/store/protocols'

export default [
    {
        name:'channel-short',
        path: '/shorts/index.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_SHORT.join('/')
        }
    }
]